import { oc } from 'ts-optchain';

import { StoreType } from '@tock/shared/utils/connect';
import { createDeepEqualSelector } from 'utils/service/selectorUtils';
import { createSelector } from 'reselect';
import { forEach } from 'es-toolkit/compat';
import { isEqual } from 'es-toolkit';

let existing: Dictionary<number[]> | undefined = {};
export const partyToTableSelector = createDeepEqualSelector(
  (state: StoreType) => oc(state).service.app.app.partyIdToTableId(),
  (partyIdToTableId) => {
    if (partyIdToTableId && existing) {
      forEach(partyIdToTableId, (entry, key) => {
        if (existing && existing[key] && isEqual(entry, existing[key])) {
          partyIdToTableId[key] = existing[key];
        }
      });
    }
    existing = partyIdToTableId;
    return partyIdToTableId || {};
  }
);

export const tableToPartySelector = createSelector(partyToTableSelector, (partyIdToTableId) => {
  const tables: Dictionary<number[]> = {};
  forEach(partyIdToTableId, (tableIds, partyIdString: string) => {
    const partyId = parseInt(partyIdString, 10);
    forEach(tableIds, (tableId) => {
      if (tables[tableId]) {
        tables[tableId].push(partyId);
      } else {
        tables[tableId] = [partyId];
      }
    });
  });
  return tables || {};
});
